import { styled } from "@mui/material";

import twToCss from "utils/twToCssHelper";

export const Btn = styled("button")`
	${twToCss("relative rounded-[20px] w-full bg-yellow-400 p-[3px] bg-yellow-400")};

	box-shadow: 0 1px 0 0 white inset;

	&:before {
		content: "";

		${twToCss("absolute top-1 left-0 w-full h-full z-[-1] rounded-[20px]")};

		background: linear-gradient(180deg, #450905 92.79%, #af0707 100%);
		box-shadow: 0 -1px 0 0 rgba(212, 62, 39, 0.6) inset;
	}

	.btn-content {
		${twToCss("w-full h-fit border-none rounded-[17px] p-[3px]")};
		background: linear-gradient(180deg, #450905 0%, #af0707 100%);
	}

	.btn-selector {
		${twToCss("rounded-[20px] flex-1 h-full flex items-center justify-between gap-2 p-0.5")};

		background: linear-gradient(180deg, #ff574b 0%, #bb1509 71.5%, #ff3e30 100%);
		box-shadow: 0 -1px 0 0 #ff6358 inset;
	}

	.dropdown {
		border-bottom-left-radius: 21px;
		border-bottom-right-radius: 21px;

		&::-webkit-scrollbar {
			width: 0;
			height: 0;
		}
	}

	&.collapsed {
		${twToCss("w-6 h-6 p-0 rounded-full")};

		.btn-content {
			${twToCss("p-0")};
		}

		.btn-selector {
			${twToCss("p-0")};
		}

		&:before {
			display: none;
		}
	}
`;
